import { useContext } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { NewPlanStages } from './constants';
import { getImageBasePath } from 'utils/generics';
import Header from 'widgets/header';
import { useFetchParams } from 'hooks/useFetchParams';
import MobileModal from './mobileModels';
import Plans from './plans';
import CustomerDetails from './customerDetails';
import CustomerLink from './customerLink';
import Congratulations from 'widgets/congratulations';
import { MPosContext } from 'utils/context';
import * as Styles from './styles';
import VehicleDetails from './vehicleDetails';
import ReviewDetails from './reviewDetails';
import { getPlanStageBackFromReviewDetails } from './utils';
import {
    SegmentEventActionTypes,
    SegmentEventNameTypes,
    SegmentEventActionNames,
} from 'utils/segment/constants';
import sendSegmentEvent from 'utils/segment';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';

function NewPlan() {
    const { lob, partner } = useFetchParams();

    const router = useRouter();

    const {
        activeStage: stage,
        setActiveStage,
        permissions,
        planDetails,
        userDetails,
    } = useContext(MPosContext);
    const { isMobile } = useResponsiveDevice();

    const onBack = () => {
        /**
         * Segment event
         */
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.CLICK_BACK_BUTTON,
                button_name: `click_${stage}_back_button`,
            },
            { userDetails, isMobile }
        );
        const planStageBackFromReviewDetails =
            getPlanStageBackFromReviewDetails(permissions, planDetails);
        switch (stage) {
            case NewPlanStages.MODEL:
                router.push(`/${lob}/${partner}/dashboard`);
                return;
            case NewPlanStages.PLAN:
                setActiveStage(NewPlanStages.MODEL);
                return;
            case NewPlanStages.VEHICLE_DETAILS:
                setActiveStage(NewPlanStages.PLAN);
                return;
            case NewPlanStages.USER_DETAILS:
                setActiveStage(NewPlanStages.VEHICLE_DETAILS);
                return;
            case NewPlanStages.REVIEW_DETAILS:
                setActiveStage(planStageBackFromReviewDetails);
                return;
            case NewPlanStages.CUSTOMER_LINK:
                setActiveStage(NewPlanStages.REVIEW_DETAILS);
                return;
            case NewPlanStages.CONGRATULATION:
                router.push(`/${lob}/${partner}/dashboard`);
                return;
            default:
                setActiveStage(NewPlanStages.MODEL);
        }
    };

    const activeNewPlanStage = () => {
        switch (stage) {
            case NewPlanStages.MODEL:
                return <MobileModal />;
            case NewPlanStages.PLAN:
                return <Plans />;
            case NewPlanStages.VEHICLE_DETAILS:
                return <VehicleDetails />;
            case NewPlanStages.USER_DETAILS:
                return <CustomerDetails />;
            case NewPlanStages.CUSTOMER_LINK:
                return <CustomerLink />;
            case NewPlanStages.REVIEW_DETAILS:
                return <ReviewDetails />;
            case NewPlanStages.CONGRATULATION:
                return (
                    <Congratulations
                        message={`Plan details shared with customer, waiting for customer to pay`}
                    />
                );
            default:
                return <MobileModal />;
        }
    };

    return (
        <Styles.Wrapper>
            <Header />
            <Styles.Header>
                <Styles.BackArrowIcon>
                    <Image
                        width={'10px'}
                        height={'24px'}
                        alt={''}
                        src={getImageBasePath('/icons/backArrow.svg')}
                        onClick={onBack}
                    />
                </Styles.BackArrowIcon>
            </Styles.Header>
            {activeNewPlanStage()}
        </Styles.Wrapper>
    );
}

export default NewPlan;
